import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { ToggleDarkMode } from '../../shared/ui/toggle-dark-mode/toggle-dark-mode';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { InfoDialogComponent } from '../../shared/ui/info-dialog/info-dialog.component';
import { AuthService } from '../../core/service/auth.service';
import { CONTACT_URL } from '../../shared/constants/app.constants';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, NgOptimizedImage, ToggleDarkMode, RouterLink, InfoDialogComponent],
  templateUrl: './auth-layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayout {
  private router = inject(Router);
  public authService = inject(AuthService);

  readonly contactUrl = CONTACT_URL;

  /** Signal to track the current url path */
  currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  /** Computed route info based on the current url */
  routeInfo = computed(() => {
    const url = this.currentUrl();
    if (url.includes('signup')) {
      return {
        path: '/login',
        text: 'Hai già un account? Accedi',
      };
    }
    if (url.includes('forgot-password') || url.includes('reset-password')) {
      return {
        path: '/login',
        text: 'Torna al login',
      };
    }
    return {
      path: '/signup',
      text: 'Non hai un account? Registrati',
    };
  });

  closeSignupSuccessDialog(): void {
    this.authService.signupSuccessDialogOpen.set(false);
    this.router.navigate(['/login']);
  }

  closePasswordResetRequestDialog(): void {
    this.authService.passwordResetRequestSuccessDialogOpen.set(false);
    this.router.navigate(['/login']);
  }

  closePasswordResetConfirmDialog(): void {
    this.authService.passwordResetConfirmSuccessDialogOpen.set(false);
    this.router.navigate(['/login']);
  }
}
